import { render, staticRenderFns } from "./FeedChart.vue?vue&type=template&id=5648c97b&scoped=true"
import script from "./FeedChart.vue?vue&type=script&lang=js"
export * from "./FeedChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5648c97b",
  null
  
)

export default component.exports